(function () {
  'use strict';

  var root = document.querySelector('[data-pd-welcome]');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';

  var overlay = root.querySelector('[data-pd-welcome-overlay]');
  var dialog = root.querySelector('[data-pd-welcome-dialog]');
  var pageRoot = document.getElementById('root');
  var closeButton = root.querySelector('[data-pd-welcome-close]');
  var nextButton = root.querySelector('[data-pd-welcome-next]');
  var form = document.getElementById('pd-welcome-form');
  var emailInput = document.getElementById('pd-welcome-email');
  var errorRegion = root.querySelector('[data-pd-welcome-error]');
  var formResult = root.querySelector('[data-pd-welcome-form-result]');
  var teaser = root.querySelector('[data-pd-welcome-teaser]');
  var teaserOpen = root.querySelector('[data-pd-welcome-teaser-open]');
  var teaserClose = root.querySelector('[data-pd-welcome-teaser-close]');
  var copyButton = root.querySelector('[data-pd-welcome-copy]');
  var copyStatus = root.querySelector('[data-pd-welcome-copy-status]');
  var panels = root.querySelectorAll('[data-pd-welcome-panel]');
  var discountCode = root.dataset.discountCode || 'GET10OFF';
  var configuredDelay = Number(root.dataset.delayMs);
  var configuredSuppression = Number(root.dataset.suppressionDays);
  var delayMs = Number.isFinite(configuredDelay) && configuredDelay >= 0 ? configuredDelay : 8000;
  var suppressionDays = Number.isFinite(configuredSuppression) && configuredSuppression > 0 ? configuredSuppression : 3;
  var timerId = null;
  var previousFocus = null;
  var previousPageAriaHidden = null;
  var previousPageInert = false;

  var keys = {
    state: 'pd_welcome_state',
    teaserClosedUntil: 'pd_welcome_teaser_closed_until',
    subscribed: 'pd_welcome_subscribed',
    submissionPending: 'pd_welcome_submission_pending',
    returnUrl: 'pd_welcome_return_url',
    showSuccess: 'pd_welcome_show_success'
  };

  function storageGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {}
  }

  function storageRemove(storage, key) {
    try {
      storage.removeItem(key);
    } catch (error) {}
  }

  function isSuppressed() {
    var closedUntil = Number(storageGet(window.localStorage, keys.teaserClosedUntil));
    if (!closedUntil) return false;
    if (Date.now() < closedUntil) return true;
    storageRemove(window.localStorage, keys.teaserClosedUntil);
    return false;
  }

  function isSubscribed() {
    return storageGet(window.localStorage, keys.subscribed) === 'true';
  }

  function setPanel(name) {
    panels.forEach(function (panel) {
      panel.hidden = panel.dataset.pdWelcomePanel !== name;
    });
    dialog.setAttribute('aria-labelledby', 'pd-welcome-' + name + '-title');
  }

  function getFocusableElements() {
    return Array.prototype.slice.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
    ).filter(function (element) {
      return !element.hidden && element.getClientRects().length > 0;
    });
  }

  function lockPage() {
    document.body.classList.add('pd-welcome-scroll-locked');
    if (!pageRoot) return;
    previousPageAriaHidden = pageRoot.getAttribute('aria-hidden');
    previousPageInert = 'inert' in pageRoot ? pageRoot.inert : false;
    pageRoot.setAttribute('aria-hidden', 'true');
    if ('inert' in pageRoot) pageRoot.inert = true;
  }

  function unlockPage() {
    document.body.classList.remove('pd-welcome-scroll-locked');
    if (!pageRoot) return;
    if (previousPageAriaHidden === null) {
      pageRoot.removeAttribute('aria-hidden');
    } else {
      pageRoot.setAttribute('aria-hidden', previousPageAriaHidden);
    }
    if ('inert' in pageRoot) pageRoot.inert = previousPageInert;
  }

  function openModal(panelName, focusTarget) {
    window.clearTimeout(timerId);
    timerId = null;
    previousFocus = document.activeElement;
    root.hidden = false;
    teaser.hidden = true;
    setPanel(panelName);
    overlay.hidden = false;
    lockPage();
    window.requestAnimationFrame(function () {
      (focusTarget || dialog).focus({ preventScroll: true });
    });
  }

  function showTeaser(shouldFocus) {
    root.hidden = false;
    teaser.hidden = false;
    if (shouldFocus) teaserOpen.focus();
  }

  function closeModal() {
    var wasSuccess = !root.querySelector('[data-pd-welcome-panel="success"]').hidden;
    overlay.hidden = true;
    unlockPage();

    if (!wasSuccess && !isSubscribed()) {
      setPanel('splash');
      storageSet(window.localStorage, keys.state, 'teaser');
      showTeaser(true);
      return;
    }

    teaser.hidden = true;
    root.hidden = true;
    if (previousFocus && document.contains(previousFocus)) previousFocus.focus();
  }

  function handleKeydown(event) {
    if (overlay.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }
    if (event.key !== 'Tab') return;

    var focusable = getFocusableElements();
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function showClientError(message) {
    errorRegion.textContent = message;
    errorRegion.hidden = false;
    emailInput.setAttribute('aria-invalid', 'true');
  }

  function clearClientError() {
    if (!emailInput.validity.valid) return;
    errorRegion.textContent = '';
    errorRegion.hidden = true;
    emailInput.removeAttribute('aria-invalid');
  }

  function resetAcquisitionForm() {
    form.reset();
    errorRegion.textContent = '';
    errorRegion.hidden = true;
    emailInput.removeAttribute('aria-invalid');
    setPanel('splash');
  }

  function anotherThemeOverlayIsOpen() {
    return (
      document.documentElement.classList.contains('popup-shown') ||
      document.documentElement.classList.contains('page-blocked') ||
      (pageRoot && (pageRoot.inert || pageRoot.getAttribute('aria-hidden') === 'true'))
    );
  }

  function scheduleAutomaticOpen(waitMs) {
    timerId = window.setTimeout(function () {
      if (anotherThemeOverlayIsOpen()) {
        scheduleAutomaticOpen(1000);
        return;
      }
      openModal('splash');
    }, waitMs);
  }

  function currentReturnUrl() {
    return window.location.pathname + window.location.search;
  }

  function applyDiscountAfterSuccess() {
    var returnUrl = storageGet(window.sessionStorage, keys.returnUrl) || currentReturnUrl();
    var storefrontRoot = root.dataset.rootUrl || '/';
    if (storefrontRoot.charAt(storefrontRoot.length - 1) !== '/') storefrontRoot += '/';

    storageRemove(window.sessionStorage, keys.submissionPending);
    storageRemove(window.sessionStorage, keys.returnUrl);
    storageRemove(window.localStorage, keys.state);
    storageSet(window.localStorage, keys.subscribed, 'true');
    storageSet(window.sessionStorage, keys.showSuccess, 'true');

    window.location.assign(
      storefrontRoot + 'discount/' + encodeURIComponent(discountCode) + '?redirect=' + encodeURIComponent(returnUrl)
    );
  }

  closeButton.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) closeModal();
  });
  document.addEventListener('keydown', handleKeydown);

  nextButton.addEventListener('click', function () {
    setPanel('email');
    dialog.focus({ preventScroll: true });
  });

  teaserOpen.addEventListener('click', function () {
    storageRemove(window.localStorage, keys.state);
    resetAcquisitionForm();
    openModal('splash');
  });

  teaserClose.addEventListener('click', function () {
    window.clearTimeout(timerId);
    timerId = null;
    storageRemove(window.localStorage, keys.state);
    storageSet(
      window.localStorage,
      keys.teaserClosedUntil,
      String(Date.now() + suppressionDays * 24 * 60 * 60 * 1000)
    );
    teaser.hidden = true;
    overlay.hidden = true;
    root.hidden = true;
  });

  emailInput.addEventListener('invalid', function () {
    showClientError(emailInput.validity.valueMissing ? 'Enter your email address.' : 'Enter a valid email address.');
  });
  emailInput.addEventListener('input', clearClientError);

  form.addEventListener('submit', function () {
    if (!form.checkValidity()) return;
    storageSet(window.sessionStorage, keys.submissionPending, 'true');
    storageSet(window.sessionStorage, keys.returnUrl, currentReturnUrl());
  });

  copyButton.addEventListener('click', function () {
    if (!navigator.clipboard || !navigator.clipboard.writeText) return;
    navigator.clipboard.writeText(discountCode).then(function () {
      copyStatus.textContent = 'Copied!';
      window.setTimeout(function () {
        copyStatus.textContent = '';
      }, 1800);
    }).catch(function () {});
  });

  root.hidden = false;

  if (storageGet(window.sessionStorage, keys.showSuccess) === 'true') {
    storageRemove(window.sessionStorage, keys.showSuccess);
    storageRemove(window.sessionStorage, keys.submissionPending);
    storageRemove(window.sessionStorage, keys.returnUrl);
    storageRemove(window.localStorage, keys.state);
    openModal('success', copyButton);
    return;
  }

  var popupSubmissionPending = storageGet(window.sessionStorage, keys.submissionPending) === 'true';
  var formSucceeded = formResult.dataset.success === 'true';
  var formHasErrors = formResult.dataset.hasErrors === 'true';

  if (popupSubmissionPending && formSucceeded) {
    applyDiscountAfterSuccess();
    return;
  }

  if (popupSubmissionPending && formHasErrors) {
    storageRemove(window.sessionStorage, keys.submissionPending);
    openModal('email');
    emailInput.setAttribute('aria-invalid', 'true');
    return;
  }

  storageRemove(window.sessionStorage, keys.submissionPending);
  storageRemove(window.sessionStorage, keys.returnUrl);

  if (root.dataset.designMode === 'true') {
    root.hidden = true;
    return;
  }

  if (isSubscribed()) {
    root.hidden = true;
    return;
  }

  if (isSuppressed()) {
    root.hidden = true;
    return;
  }

  if (storageGet(window.localStorage, keys.state) === 'teaser') {
    showTeaser(false);
    return;
  }

  scheduleAutomaticOpen(delayMs);
})();
